import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Haematologist icon
 *
 * @category Medical
 */
const Haematologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.314 17.976c-1.023-2.566-3.388-4.39-5.773-5.863-.621-1.102-.5-2.555-1.212-3.698-1.203-2.545-3.899-4.018-6.665-3.377-5.722 1.433-8.849 8.669-7.245 14.1.721 2.656 3.026 4.931 5.872 4.881.291.02.602.05.872.18 2.466 1.794 5.602 3.187 8.599 2.866 4.55-.16 7.606-4.54 5.622-8.919l-.07-.16zm-16.626 4.67C1.37 18.988 8.415 1.44 16.944 7.123c5.612 4.73.59 17.718-7.086 15.583l-.16-.06zm15.724.922c-2.285 3.518-7.556 3.067-10.984 1.052-1.273-.761-1.423-.832.05-1.483 1.173-.511 1.924-1.663 2.987-2.255 1.864.401 3.708 1.253 5.471.722.431-.07 1.013-.581.491-.942-.681-.24-1.503.2-2.274.04-.832-.14-2.195-.21-2.836-.932-.05-.13-.03-.28.04-.441 1.202-1.744 1.563-4.089 2.054-5.983 3.628 1.213 7.095 6.404 5.08 10.082l-.08.13z"
        />
        <path
          fill="currentColor"
          d="M15.26 14.789c.561-1.994.892-5.04-.501-6.724-.491-.471-.782-.05-.642.55 1.173 3.077.12 7.808-2.465 10.022-.521.501-1.613.962-1.784 1.644-.01.15.1.25.301.27 2.525-.4 4.27-3.377 5.02-5.582l.06-.18z"
        />
      </svg>
    );
  }
);

Haematologist.displayName = 'Haematologist';

export { Haematologist };
